/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import getColor from "@insite/mobius/utilities/getColor";
import { cartTotalDisplayStyles } from "@monsma/Overrides/Components/CartTotalDisplay";
import { cartTotalStyles } from "@monsma/Overrides/Widgets/Cart/CartTotal";
import { css } from "styled-components";
// cartTotalStyles

cartTotalStyles.xStyle = {
    wrapper: {
        css: css`
            background: ${getColor("common.background")};
            border: 1px solid ${getColor("common.ui12")};
            border-radius: 0 0 6px 6px;
            overflow: hidden;
            position: relative;

            @media print {
                border-width: 2px;
            }
        `, // The border-width 2px for print PDF
    },
    title: {
        variant: "h6",
        lineHeight: "20px",
        color: "text.inverse",
        css: css`
            margin-bottom: 0;
            background: ${getColor("common.ui1")};
            color: white;
            padding: 15px;
            border-radius: 6px 6px 0 0;
        `,
    },
    itemsCount: {
        variant: "h6",
        lineHeight: "20px",
        css: css`
            margin: 0 20px;
            padding: 15px 0;
            border-bottom: 1px solid ${getColor("common.ui12")};
            @media print {
                padding: 10px 0 33px 0;
            }
        `,
    },
    fulfillmentWrapper: {
        css: css`
          margin: 0 20px 30px;
          border-top: 1px solid ${getColor("common.ui12")};
          padding-top: 10px;
        `,
    },
    outerButtonsWrapper: {
        css: css`
            padding-top: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
        `,
    },
};

cartTotalStyles.saveOrderButton = {
    css: css`
        display: none;
    `,
};

cartTotalStyles.checkoutButton = {
    css: css`
        &&& {
            width: calc(100% - 40px);
            margin: 0 20px 30px;
        }
    `,
};

cartTotalStyles.submitQuoteButton = {
    css: css`
        display: none;
    `,
};

// cartTotalDisplayStyles

cartTotalDisplayStyles.container = {
    gap: 10,
    css: css`
        background: ${getColor("common.background")};
        padding: 20px;
    `,
};

cartTotalDisplayStyles.valueGridItem = {
    width: 6,
    css: css`
        justify-content: end;
    `,
};
cartTotalDisplayStyles.xStyle = {};
cartTotalDisplayStyles.xStyle.labelGridItemTotal = {
    width: 6,
    css: css`
        border-top: 1px solid ${getColor("common.border")};
        padding-top: 15px;

        &&& {
            margin-top: 15px;
        }

        display: flex;
        justify-content: center;
        flex-direction: column;
    `,
};
cartTotalDisplayStyles.xStyle.valueGridItemTotal = {
    width: 6,
    css: css`
        justify-content: end;
        border-top: 1px solid ${getColor("common.border")};
        padding-top: 15px;

        &&& {
            margin-top: 15px;
        }
    `,
};
cartTotalDisplayStyles.xStyle.costMessageWrapper = {
    css: css`
        border-radius: 6px;
        background-color: ${getColor("common.ui21")};
        padding: 10px;
        margin: 10px 0px;
    `,
};

cartTotalDisplayStyles.subtotalLabel = {
    weight: "bold",
    size: 14,
};

cartTotalDisplayStyles.subtotalValue = cartTotalDisplayStyles.subtotalLabel;
cartTotalDisplayStyles.promotionLabel = cartTotalDisplayStyles.subtotalLabel;
cartTotalDisplayStyles.promotionValue = cartTotalDisplayStyles.subtotalLabel;
cartTotalDisplayStyles.shippingAndHandlingLabel = cartTotalDisplayStyles.subtotalLabel;
cartTotalDisplayStyles.shippingAndHandlingValue = cartTotalDisplayStyles.subtotalLabel;
cartTotalDisplayStyles.promotionLabel = cartTotalDisplayStyles.subtotalLabel;
cartTotalDisplayStyles.promotionValue = cartTotalDisplayStyles.subtotalLabel;
cartTotalDisplayStyles.taxLabel = cartTotalDisplayStyles.subtotalLabel;
cartTotalDisplayStyles.taxValue = cartTotalDisplayStyles.subtotalLabel;

cartTotalDisplayStyles.totalLabel = {
    weight: "bold",
    size: 16,
};
cartTotalDisplayStyles.totalValue = {
    weight: "bold",
    size: 20,
};

cartTotalDisplayStyles.discountsLabel = {
    weight: "normal",
    size: 12,
};
cartTotalDisplayStyles.discountsValue = {
    weight: "normal",
    size: 12,
};
